import React from "react";
import Shelf from "./Shelf";
import I18n from "i18n.js.erb";
import ExpoTotemCellContainer from "./ExpoTotemCellContainer";

const ExpoTotemGrid = ({ totem, cellsSize, highlightedCells, hasActiveSearch, onLabelClick, eInkSmartLabelOnHoverMouceIcon }) => {
  if (!totem || !totem.cells) return null;

  // Raggruppo le celle per riga: da lista piatta a { 1: [celle], 2: [celle], ... }
  const cellsByRow = {};
  totem.cells.forEach(cell => {
    if (!cellsByRow[cell.row]) cellsByRow[cell.row] = [];
    cellsByRow[cell.row].push(cell);
  });

  // Numeri di riga ordinati crescenti
  const rowNumbers = Object.keys(cellsByRow).map(Number).sort((a, b) => a - b);

  // Per ogni riga costruisco uno scaffale con le sole celle esistenti, ordinate per colonna
  const shelves = rowNumbers.map(row => {
    const sortedCells = cellsByRow[row].slice().sort((a, b) => a.col - b.col);
    const shelfCells = sortedCells.map(cell => ({
      row,
      col: cell.col,
      key: `${row}-${cell.col}`,
      cell,
    }));
    return { row, cells: shelfCells };
  });


  return (
    <div className="loop-totem-shelves">
      {shelves.map(({ row, cells: shelfCells }) => (
        <Shelf key={row} label={`${I18n.t('js.loopDashboard.shelf')} ${row}`}>
          <div className={`loop-shelf__cells${cellsSize === 'small' ? ' loop-shelf__cells--small' : ''}`}>
            {shelfCells.map(({ key, cell }) => {
              const isHighlighted = highlightedCells && highlightedCells.has(key);
              const isDimmed = hasActiveSearch && !isHighlighted;

              return <ExpoTotemCellContainer
                key={key}
                isDimmed={isDimmed}
                cell={cell}
                onLabelClick={onLabelClick}
                cellSize={cellsSize}
                eInkSmartLabelOnHoverMouceIcon={eInkSmartLabelOnHoverMouceIcon}
              />
            })}
          </div>
        </Shelf>
      ))}
    </div>
  );
};

export default ExpoTotemGrid;
